import NiceModal from "@ebay/nice-modal-react";
import {LicenseInfo} from "@mui/x-license";
import {MUIProLicense} from "@bounce/shared/constants";
import {BrowserRouter} from "react-router-dom";
import {QueryClientProvider} from "@tanstack/react-query";
import {ThemeConfig, Toast} from "@bounce/shared/ui";
import palette from "./ui/palette";
import {queryClient} from "@bounce/shared/requests";
import Router from "./routes/routes";
import {ReactQueryDevtools} from "@tanstack/react-query-devtools";
import ReachApiExceptionManager from "./apis/ReachApiExceptionManager";

export default function App() {
  LicenseInfo.setLicenseKey(MUIProLicense);
  return (
    <BrowserRouter future={{v7_relativeSplatPath: true, v7_startTransition: true}}>
      <QueryClientProvider client={queryClient}>
        <ThemeConfig palette={palette}>
          <Toast />
          <ReachApiExceptionManager />
          <ReactQueryDevtools initialIsOpen={false} />
          <NiceModal.Provider>
            <Router />
          </NiceModal.Provider>
        </ThemeConfig>
      </QueryClientProvider>
    </BrowserRouter>
  );
}
